import React, { useState, useEffect } from "react";
import { DataGridPro } from '@mui/x-data-grid-pro';
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../../../config";

export default function EvvProcedure(props) {
    const columns = [
        { field: 'id', headerName: 'id', width: 100 },
        { field: 'taskType', headerName: 'TYPE', width: 250, },
        {
            field: 'description',
            headerName: 'DESCRIPTION',
            flex: 1,
            renderCell: (params) => {
                return (
                    <div>
                        <p className="text-wrap">{params.value} </p>
                    </div>
                )
            }
        },
        { field: 'unit', headerName: 'UNIT', width: 150, },
        { field: 'code', headerName: 'CODE', width: 150,},
        { field: 'modifierCode', headerName: 'MODIFIER', width: 150, },
        { field: 'deliveryMode', headerName: 'DELIVERY MODE', width: 150, },
    ]

    const rows = props.data
        .filter((rec) => rec.procTaskType)
        .map((rec) => {
            const procData = {
                id: rec.procCode_id,
                description: rec.procCode_description,
                unit: rec.procUnitOfService,
                code: rec.procProcCode,
                modifierCode: rec.procModifierCode,
                taskType: rec.procTaskType,
                state: rec.state_id,
                deliveryMode: rec.deliveryMode
            };
            return procData;
        });

    return (
        <div style={{ margin: "auto", width: '100%', display: 'flex' }}>
            <DataGridPro
                initialState={{
                    sorting: { sortModel: [{ field: "description", sort: "asc" }] },
                    density: 'compact',
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                            modifierCode: false,
                        },
                    },
                }}
                rows={rows}
                columns={columns}
                showToolbar
            />
        </div>
    );
};